// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__HdoV8","dot":"index_dot__NnywQ","dotter":"index_dotter__Fs2r+","glow":"index_glow__6iXBy"};